import { GameMode } from "@rosette/ts/src/business/game/GameMode.js";
import type { StaticImageData } from "next/image";
import computerIcon from "@rosette/assets/src/buttons/mode_computer.svg";
import friendIcon from "@rosette/assets/src/buttons/mode_friend.svg";
import onlineIcon from "@rosette/assets/src/buttons/mode_online.svg";
import localIcon from "@rosette/assets/src/buttons/mode_local.svg";


export function getGameModeIcon(mode: GameMode): StaticImageData {
    if (mode === GameMode.COMPUTER)
        return computerIcon;
    if (mode === GameMode.FRIEND)
        return friendIcon;
    if (mode === GameMode.ONLINE)
        return onlineIcon;
    if (mode === GameMode.LOCAL)
        return localIcon;

    throw new Error(`Unknown game mode, ${mode.getID()}`);
}
